import React from "react";

type TableContainerProps = {
  children: React.ReactNode;
};

const TableContainer: React.FC<TableContainerProps> = ({ children }) => (
  <table className="min-w-full mt-2 border-separate border-spacing-0 rounded-lg shadow-ground-1 overflow-hidden">
    {children}
  </table>
);

export default TableContainer;
